// extracted by mini-css-extract-plugin
export default {"base":"hero-module--base--hsyJI","fullScreen":"hero-module--fullScreen--bwf2F","inner":"hero-module--inner--7poDH","heroMobile":"hero-module--heroMobile--CQANq"};